import { ResponseValid } from 'domain/utils/ReactUtils';
import { UsuarioSistemaPerfilService } from 'domain/services/usuarioSistemaPerfil/usuarioSistemaPerfilService';

import { USUARIO_SISTEMA_PERFIL_GET } from 'domain/types/usuarioSistemaPerfil/usuarioSistemaPerfil';
import { AppThunk } from '../../../utils/reducerUtil';

const _UsuarioSistemaPerfilService = new UsuarioSistemaPerfilService();

export function GetUsuarioSistemaPerfil(usuarioID: number): AppThunk {
    return async (dispatch) => {
        const asyncResponse = await _UsuarioSistemaPerfilService.GetUsuarioSistemaPerfil(usuarioID)
        if (ResponseValid(asyncResponse, false)) {
            dispatch({
                payload: asyncResponse,
                type: USUARIO_SISTEMA_PERFIL_GET
            })
        }
    }
}
